var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationFolderOpen = function SvgSimpleIllustrationFolderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.533 34.96s1.353-.795 1.353-1.432c0-.638 2.148-13.77 2.148-13.77s.238-1.273-1.273-1.273H14.68s-1.035 0-1.353.716c-.317.715-2.626 15.442-2.626 15.442l24.833.318Z",
    fill: "#FFD7B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 13.231s-1.99.875-1.99 1.99v18.864s.793.543 1.035.637c.243.095 1.193-.08 1.193-.08l2.706-15.84s1.353-.237 1.67-.237c.318 0 20.297-.398 20.297-.398l-.398-2.468s-.397-.557-1.115-.557-15.76.397-15.76.397l-1.193-.795-1.593-1.433-4.854-.08h.002Z",
    fill: "#FFC68C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.545 15.393c0-1.129.916-2.042 2.043-2.042h4.517a2.04 2.04 0 0 1 1.57.734l.724.868a.857.857 0 0 0 .655.306h16.543c.47 0 .852.381.852.852v2.2",
    stroke: "#002140",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.597 34.814 2.619-15.456a1.127 1.127 0 0 1 1.113-.939h23.604a1.13 1.13 0 0 1 1.113 1.318l-2.397 14.14a1.127 1.127 0 0 1-1.113.94H9.746a1.193 1.193 0 0 1-1.194-1.193l-.009-18.229M11.178 32.254h25.708",
    stroke: "#002140",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSimpleIllustrationFolderOpen;